import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    subject: '',
    group: '',
    teacher: '',
    grade_level: '',
    term: '',
  },
}

export const coursesUI = createSlice({
  name: 'coursesUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setTeacher: (state, { payload }) => {
      state.tableFilters.teacher = payload
    },    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.term = payload
    },
    setTerm: (state, { payload }) => {
      state.tableFilters.term = payload
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setSubject,
  setGroup,
  setTeacher,
  setGradeLevel,
  setTerm,
  trackActiveFilters,
  clearAllFilters,
} = coursesUI.actions

export default coursesUI.reducer
